import React, { useState } from "react";

const Certifications = () => {
  const [certifications, setCertifications] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Handle input changes for editable fields
  const handleInputChange = (index, field, value) => {
    const updatedCertifications = [...certifications];
    updatedCertifications[index][field] = value;
    setCertifications(updatedCertifications);
  };

  // Add a new certification
  const addCertification = () => {
    setCertifications([
      ...certifications,
      { name: "", link: "", startDate: "", endDate: "" },
    ]);
  };

  // Delete a certification
  const deleteCertification = (index) => {
    const updatedCertifications = certifications.filter((_, i) => i !== index);
    setCertifications(updatedCertifications);
  };

  // Save changes function
  const saveChanges = () => {
    // You can implement logic for saving changes here
    console.log("Changes Saved!");
  };

  return (
    <div className="flex flex-col w-full mr-11 bg-white rounded-3xl mt-4 h-full">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-xl m-3 ml-7 mt-4">Certifications</h1>
        <button
          className="m-3 mr-7 text-blue-600 text-xl focus:outline-none"
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? "\u25B2" : "\u25BC"}
        </button>
      </div>

      {isVisible && (
        <>
          <div className="grid grid-cols-1 gap-6 m-10 mt-4">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="border rounded-lg p-4 shadow-md bg-gray-50 relative"
              >
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <h2 className="text-gray-500">Certificate Name</h2>
                    {isEditing ? (
                      <input
                        type="text"
                        value={cert.name}
                        onChange={(e) =>
                          handleInputChange(index, "name", e.target.value)
                        }
                        className="border rounded p-2 w-full"
                      />
                    ) : (
                      <span className="text-black font-semibold">
                        {cert.name || "Not Provided"}
                      </span>
                    )}
                  </div>

                  <div>
                    <h2 className="text-gray-500">Link</h2>
                    {isEditing ? (
                      <input
                        type="text"
                        value={cert.link}
                        onChange={(e) =>
                          handleInputChange(index, "link", e.target.value)
                        }
                        className="border rounded p-2 w-full"
                      />
                    ) : (
                      <a
                        href={cert.link || "#"}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline break-words"
                      >
                        {cert.link || "Not Provided"}
                      </a>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <h2 className="text-gray-500">Start Date</h2>
                    {isEditing ? (
                      <input
                        type="text"
                        value={cert.startDate}
                        onChange={(e) =>
                          handleInputChange(index, "startDate", e.target.value)
                        }
                        className="border rounded p-2 w-full"
                      />
                    ) : (
                      <span className="text-black font-semibold">
                        {cert.startDate || "Not Provided"}
                      </span>
                    )}
                  </div>

                  <div>
                    <h2 className="text-gray-500">End Date</h2>
                    {isEditing ? (
                      <input
                        type="text"
                        value={cert.endDate}
                        onChange={(e) =>
                          handleInputChange(index, "endDate", e.target.value)
                        }
                        className="border rounded p-2 w-full"
                      />
                    ) : (
                      <span className="text-black font-semibold">
                        {cert.endDate || "Not Provided"}
                      </span>
                    )}
                  </div>
                </div>

                <button
                  onClick={() => deleteCertification(index)}
                  className="text-red-600 hover:text-red-800 flex items-center justify-center mt-2"
                >
                  🗑️ Delete
                </button>
              </div>
            ))}
          </div>

          {isEditing && (
            <div className="flex justify-center mb-6">
              <button
                onClick={addCertification}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Add Certification
              </button>
            </div>
          )}

          <div className="flex flex-col items-center">
            <button
              onClick={() => setIsEditing(!isEditing)}
              className={`flex w-48 mb-2 pt-1 pr-2 text-lg rounded ${
                isEditing
                  ? "bg-gray-600 text-white items-center justify-center"
                  : "bg-blue-600 text-white items-center justify-center hover:bg-white hover:text-blue-600 hover:border-2 hover:border-blue-600"
              }`}
            >
              {isEditing ? "Cancel Edit" : "Edit"}
            </button>

            {isEditing && (
              <button
                onClick={saveChanges}
                className="bg-green-600 text-white px-4 py-2 rounded mb-6 hover:bg-green-700"
              >
                Save Changes
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Certifications;
